import { george, pr, theme } from "aaa";
import { GdsFakeActionButton } from "components/common/GdsFakeActionButton";
import { ui } from "components/util/uiHelpers";
import * as QRCode from "qrcode.react";
import * as React from "react";
import { pushRoute } from "stores/RouterFunctions";
import { history } from "stores/RouterStore";
import { LoginManagementRoutes } from "./LoginManagementRoutes";

export const LoginManagementActivateGeorgeId = () => {
    const handleBack = async () => {
        if (history.location.pathname.startsWith(LoginManagementRoutes.SID)) {
            pushRoute(LoginManagementRoutes.SID);
        } else if (history.location.pathname.startsWith(LoginManagementRoutes.CARDTAN)) {
            pushRoute(LoginManagementRoutes.CARDTAN);
        }
    };

    return (
        <george.Background>
            <george.Card style={{ marginBottom: theme.MARGIN_SMALL, marginTop: theme.HEADER_CONTENT_SPACING }}>
                <div style={{ padding: theme.MARGIN, paddingBottom: 80 }}>
                    <pr.P_16_CONTENT>
                        {ui.__("sidentitySettings.georgeIdActivation.text")}
                    </pr.P_16_CONTENT>
                    <div style={{ display: "flex", justifyContent: "center", marginTop: 80 }}>
                        <QRCode
                            value={`${window.location.origin}/georgeapp`}
                        />
                    </div>
                </div>
                <pr.LightSeparatorLine />
                <div style={{ display: "flex", justifyContent: "center", padding: theme.MARGIN_LARGE }}>
                    <GdsFakeActionButton
                        style={{ display: "inline-flex" }}
                        onClick={handleBack}
                    >
                        {ui.__("a11y.back")}
                    </GdsFakeActionButton>
                </div>
            </george.Card>
        </george.Background>
    );
};


// WEBPACK FOOTER //
// ./src/components/loginManagement/LoginManagementActivateGeorgeId.tsx